import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Spinner from "react-bootstrap/Spinner";
import { CSVLink } from "react-csv"; // For exporting data

const CanvaTemplate = () => {
    const [canvas, setCanvas] = useState([]);
    const [filteredCanvas, setFilteredCanvas] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false);
    const [selectedLead, setSelectedLead] = useState(null); // To hold selected lead details
    const [searched, setSearched] = useState(false);
    const [credits, setCredits] = useState(100); // Simulating user credits
    const [userLeads, setUserLeads] = useState([]); // To store bought leads

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setLoading(true);
        fetch("https://raw.githubusercontent.com/rabiulislamrizon/Test/main/tableConvert.com_xnegmc.json")
            .then((res) => res.json())
            .then((info) => {
                setCanvas(info);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
    };

    const handleSearch = (e) => {
        const query = e.target.value;
        setSearchQuery(query);
        setSearched(true);

        if (query.trim() === "") {
            setFilteredCanvas([]);
            return;
        }

        setLoading(true);

        setTimeout(() => {
            const filtered = canvas.filter((lead) =>
                lead.Industry.toLowerCase().includes(query.toLowerCase())
            );
            setFilteredCanvas(filtered);
            setLoading(false);
        }, 500);
    };

    // Function to handle modal opening and setting selected lead
    const handleViewDetails = (canva) => {
        setSelectedLead(canva);
    };

    // Function to handle buying leads
    const handleBuyLead = (canva) => {
        if (credits <= 0) {
            alert("You don't have enough credits to buy this lead!");
            return;
        }

        // Deduct 1 credit for buying a lead
        setCredits((prevCredits) => prevCredits - 1);
        setUserLeads((prevLeads) => [...prevLeads, canva]);
        alert(`You have successfully bought the lead for ${canva["Company Name"]}`);
    };

    return (
        <div className="container my-5">
            <h2 className="text-center mb-4 fw-bold">Find Your Cold Leads Here</h2>

            {/* User Dashboard */}
            <div className="text-center mb-4">
                <h5>Your Credits: {credits}</h5>
                <h6>Leads Purchased: {userLeads.length}</h6>
            </div>

            {/* Search Bar */}
            <div className="text-center">
                <input
                    type="text"
                    className="form-control w-50 mx-auto shadow"
                    placeholder="Search by Industry..."
                    value={searchQuery}
                    onChange={handleSearch}
                />
            </div>

            {/* Preloader */}
            {loading && (
                <div className="text-center mt-3">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            )}

            {/* Show table only when searched */}
            {!loading && searched && (
                <div className="table-responsive mt-4">
                    {filteredCanvas.length > 0 ? (
                        <table className="table table-hover shadow-sm">
                            <thead className="table-dark">
                                <tr>
                                    <th>#</th>
                                    <th>Company Name</th>
                                    <th>Contact Name</th>
                                    <th>Industry</th>
                                    <th>Location</th>
                                    <th>Email</th>
                                    <th>Phone</th>
                                    <th>Website</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredCanvas.slice(0, 20).map((canva, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{canva["Company Name"]}</td>
                                        <td>{canva["Contact Name"]}</td>
                                        <td>{canva.Industry}</td>
                                        <td>{canva.Location}</td>
                                        <td>
                                            <a href={`mailto:${canva.Email}`}>{canva.Email}</a>
                                        </td>
                                        <td>
                                            <a href={`tel:${canva.Phone}`}>{canva.Phone}</a>
                                        </td>
                                        <td>
                                            <a href={`https://${canva.Website}`} target="_blank" rel="noopener noreferrer">
                                                Visit
                                            </a>
                                        </td>
                                        <td>
                                            <button
                                                className="btn btn-primary"
                                                data-bs-toggle="modal"
                                                data-bs-target="#leadModal"
                                                onClick={() => handleViewDetails(canva)}
                                            >
                                                View Details
                                            </button>
                                            <button
                                                className="btn btn-success mt-2"
                                                onClick={() => handleBuyLead(canva)}
                                            >
                                                Buy Lead
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div className="text-center mt-3 text-muted">
                            No leads found for "{searchQuery}"
                        </div>
                    )}
                </div>
            )}

            {/* Export Button */}
            <div className="text-center mt-4">
                <CSVLink
                    data={filteredCanvas}
                    className="btn btn-success"
                    filename={"leads_data.csv"}
                >
                    Export Data as CSV
                </CSVLink>
            </div>

            {/* Modal Popup */}
            <div className="modal fade" id="leadModal" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Lead Details</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {selectedLead ? (
                                <div className="text-center">
                                    <h5>{selectedLead["Company Name"]}</h5>
                                    <p><strong>Contact:</strong> {selectedLead["Contact Name"]}</p>
                                    <p><strong>Industry:</strong> {selectedLead.Industry}</p>
                                    <p><strong>Location:</strong> {selectedLead.Location}</p>
                                    <p><strong>Email:</strong> <a href={`mailto:${selectedLead.Email}`}>{selectedLead.Email}</a></p>
                                    <p><strong>Phone:</strong> <a href={`tel:${selectedLead.Phone}`}>{selectedLead.Phone}</a></p>
                                    <p><strong>Website:</strong> <a href={`https://${selectedLead.Website}`} target="_blank" rel="noopener noreferrer">Visit</a></p>
                                </div>
                            ) : (
                                <div>No lead selected</div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CanvaTemplate;
